import type { FullDatoImage } from "lib/types/datoBlocks";
import {
  SPONSORSHIP_TYPES,
  type SponsorshipType,
} from "lib/constants/sponsorship";

export const SIFTED_INSIGHTS_FEATURE_CARD_TYPES = {
  W_IMG: "w_img",
  TEXT_ONLY: "text-only",
} as const;

export type SiftedInsightsFeatureCardType =
  (typeof SIFTED_INSIGHTS_FEATURE_CARD_TYPES)[keyof typeof SIFTED_INSIGHTS_FEATURE_CARD_TYPES];

export const SIFTED_INSIGHTS_FEATURE_CARD_STATES = {
  DEFAULT: "default",
  HOVER_NOT_JOINED: "hover-not-joined",
  ACTIVE: "active",
  FOCUSED: "focused",
} as const;

export type SiftedInsightsFeatureCardState =
  (typeof SIFTED_INSIGHTS_FEATURE_CARD_STATES)[keyof typeof SIFTED_INSIGHTS_FEATURE_CARD_STATES];

export const TAG_COLORS = {
  STANDARD: "standard",
  NEUTRAL: "neutral",
  SIFTED: "sifted",
  PRO: "pro",
} as const;

export type TagColor = (typeof TAG_COLORS)[keyof typeof TAG_COLORS];

export { SPONSORSHIP_TYPES };

export const SIFTED_INSIGHTS_FEATURE_CARD_VARIANTS = {
  SIFTED: "sifted",
  PRO: "pro",
} as const;

export type SiftedInsightsFeatureCardVariant =
  (typeof SIFTED_INSIGHTS_FEATURE_CARD_VARIANTS)[keyof typeof SIFTED_INSIGHTS_FEATURE_CARD_VARIANTS];

export type SponsorInfo = {
  name?: string;
  logo?: FullDatoImage;
  sponsorshipType?: SponsorshipType | null | undefined;
};

export type SiftedInsightsFeatureCardProps = {
  type?: SiftedInsightsFeatureCardType;
  title: string;
  tag?: string;
  tagColor?: TagColor;
  isSponsored?: boolean;
  sponsorInfo?: SponsorInfo[];
  excerpt?: string;
  leftLabel?: string;
  rightLabel?: string;
  href?: string;
  backgroundImage?: FullDatoImage;
  buttonText?: string;
  hoverNotJoinedText?: string;
  variant?: SiftedInsightsFeatureCardVariant;
  state?: SiftedInsightsFeatureCardState;
  className?: string;
  onClick?: () => void;
  target?: string;
};
